import Vue from 'vue'
import Vuex from 'vuex'
import Persist from 'vuex-persistedstate'

import user from './modules/user'
import people from './modules/people'
import company from './modules/company'
import calendar from './modules/calendar'
import reservations from './modules/reservations'
import settings from './modules/settings'
import inventory from './modules/inventory'
import reports from './modules/reports'
import notifications from './modules/notifications'
import widgets from './modules/widgets'
import events from './modules/events'
import app from './modules/app'
import salesChannels from './modules/salesChannels'
import invoices from './modules/invoices'
import invoicesPage from './modules/invoicesPage'
import tickets from './modules/tickets'
import transportation from './modules/transportation'
import promocodes from './modules/promocodes'
import ota from './modules/ota'
import modal from './modules/modal'
import product from './modules/product'
import integrations from './modules/integrations'
import segments from './modules/segments'
import origins from './modules/origins'
import rules from './modules/rules'
import eventFormState from './modules/eventFormState'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        people,
        company,
        calendar,
        reservations,
        settings,
        inventory,
        reports,
        notifications,
        widgets,
        events,
        app,
        salesChannels,
        invoices,
        invoicesPage,
        tickets,
        transportation,
        promocodes,
        ota,
        modal,
        product,
        integrations,
		segments,
		origins,
        rules,
        eventFormState
    },
});

export default store



// WEBPACK FOOTER //
// ./src/store/store.js